




















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import MappingDefaults from '@/components/Products/ProductGeneralLedger/MappingDefaults.vue';
import MappingOverrides from '@/components/Products/ProductGeneralLedger/MappingOverrides.vue';

@Component({ name: 'ProductGeneralLedgerMapping', components: { MappingDefaults, MappingOverrides } })
export default class extends SaascadaVue {

    get generalLedgerMappings() {
        return ProductDetailsModule.generalLedgerMappings;
    }

}
